<template>
    <div id="tagsList" class="baseTemplate">
        <!-- begin:: mobile menu -->
        <app-mobilemenu></app-mobilemenu>
        <!-- end:: mobile menu -->

        <div class="kt-grid kt-grid--hor kt-grid--root">
            <div class="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--ver kt-page">
                <!-- begin:: home menu -->
                <app-siteconfigurationmenu activeItem="bleTagModels"></app-siteconfigurationmenu>
                <!-- end:: home menu -->

                <div class="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor kt-wrapper">
                    <!-- begin:: header -->
                    <app-header></app-header>
                    <!-- end:: header -->

                    <div class="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor">
                        <!-- begin:: Content Head -->
                        <div class="kt-subheader kt-grid__item">
                            <app-sitetitle subHeaderDescKey="tag_tagModelsSubTitle"></app-sitetitle>
                            <div class="kt-subheader__toolbar">
                                <div class="kt-subheader__wrapper" v-if="!isEmptyList">
                                    <router-link v-if="!isEmptyList" :to="{ name: 'newTagModel' }" id="tags_createNewTagModelButton" class="btn btn-brand btn-bold btn-sm btn-icon-h kt-margin-l-10" data-cy="createNewTagBtn">
                                        <i class="flaticon2-plus kt-margin-r-5"></i>
                                        {{ $t("tag_createNewTagModel") }}
                                    </router-link>
                                </div>
                            </div>
                        </div>
                        <!-- end:: Content Head -->

                        <div class="kt-content kt-grid__item kt-grid__item--fluid">
                            <!-- begin:: Content -->
                            <div class="row">
                                <div class="col-xl-12">
                                    <div class="kt-portlet kt-portlet--height-fluid kt-portlet--mobile ">
                                        <div class="kt-portlet__head kt-portlet__head--lg kt-portlet__head--noborder kt-portlet__head--break-sm">
                                            <div class="kt-portlet__head-label">
                                                <span class="kt-portlet__head-icon">
                                                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1" class="kt-svg-icon">
                                                        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                                            <rect x="0" y="0" width="24" height="24" />
                                                            <path d="M12,13.8453624 L12,18.758963 L15.3125397,16.8266482 L12,13.8453624 Z M10,12.0453624 L6.33103527,8.74329415 C5.92052525,8.37383513 5.88724683,7.74154529 6.25670585,7.33103527 C6.62616487,6.92052525 7.25845471,6.88724683 7.66896473,7.25670585 L17.6689647,16.2567059 C18.172608,16.7099848 18.0891527,17.5223646 17.503871,17.8637789 L11.503871,21.3637789 C10.8372144,21.7526619 10,21.2717908 10,20.5 L10,12.0453624 Z" id="Path-20-Copy" fill="#000000" fill-rule="nonzero" opacity="0.3" />
                                                            <path d="M12,10.4375595 L15.3984747,7.54885603 L12,5 L12,10.4375595 Z M10,3 C10,2.17595468 10.9407637,1.70557281 11.6,2.2 L17.6,6.7 C18.1131546,7.08486597 18.1363893,7.84650959 17.6476484,8.26193932 L7.64764842,16.7619393 C7.22684095,17.1196257 6.59574703,17.0684559 6.23806068,16.6476484 C5.88037434,16.226841 5.93154411,15.595747 6.35235158,15.2380607 L10,12.1375595 L10,3 Z" id="Path-20" fill="#000000" fill-rule="nonzero" />
                                                        </g>
                                                    </svg>
                                                </span>
                                                <h3 class="kt-portlet__head-title">
                                                    {{ $t("tag_tagModelsList") }}
                                                </h3>
                                            </div>
                                            <div v-if="!isEmptyList" class="kt-portlet__head-toolbar">
                                                <div class="kt-portlet__head-wrapper">
                                                    <div class="kt-portlet__head-toolbar">
                                                        <div class="row align-items-center">
                                                            <div class="col-md-12 kt-margin-b-20-tablet-and-mobile">
                                                                <div class="kt-input-icon kt-input-icon--left">
                                                                    <input type="text" :placeholder="$t('common_searchByName')" @keyup="onSearch" v-model="searchedValue" id="tags_searchInput" class="searchInputDatatable form-control form-control-sm width270" />
                                                                    <span class="kt-input-icon__icon kt-input-icon__icon--left">
                                                                        <span><i class="la la-search"></i></span>
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <!--begin emptyList component-->
                                        <app-emptylist targetObjectName="TAG_MODEL" mainTextKey="tag_modelNotFound" subTextKey="tag_modelNotFoundSubLabel" imgName="empty_tag.svg" v-bind:isDisplayed="isEmptyList"></app-emptylist>
                                        <!--end emptyList component-->
                                        <div class="kt-portlet__body kt-portlet__body--fit">
                                            <!--begin: Datatable -->
                                            <div class="kt-datatable" id="tag_models_datatable"></div>
                                            <!--end: Datatable -->
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- end:: Content -->
                        </div>
                    </div>
                    <!-- begin:: Footer -->
                    <app-footer></app-footer>
                    <!-- end:: Footer -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import i18n from "../../i18n";
import EmptyList from "./../utils/emptylist.vue";
import SiteTitle from "../site/widgets/sitetitle.vue";
import moment from "moment";
import commonVueHelper from "../../helpers/commonVueHelper";

export default {
    data() {
        return {
            siteId: this.$route.params.siteId,
            siteTagModelsTable: null,
            isEmptyList: false,
            searchedValue: "",
        };
    },

    created: function() {
        console.log("Component(TagModels)::created() - called");
        // Load site tags from backend and store the result in sites store.
        if (this.createAnotherTagType) {
            this.$router.push({ name: "newTagModel" });
        } else {
            this.getSiteTagTypes(this.$route.params.siteId);
        }
    },

    mounted: function() {
        console.log("Component(TagModels)::mounted() - Init metronic layout");
        KTLayout.init();
    },

    beforeDestroy: function() {
        console.log("Component(TagModels)::beforeDestroy() - called");
        this.searchedValue = "";
        // Reset component data
        if (this.siteTagModelsTable) {
            this.siteTagModelsTable.destroy();
            this.siteTagModelsTable = null;
        }
    },

    destroyed: function() {
        console.log("Component(TagModels)::destroyed() - called");
        // Reset store
        this.resetTagTypesState();

    },

    watch: {
        // -- Watch -- Property to perform asynchronous or expensive operations in response to changing component "data".
        siteTagTypes: function(tagTypes) {
            console.log("Component(siteAllTagTypes)::watch(SiteTagModels) called with : ", tagTypes);
            if (tagTypes) {
                setTimeout(() => {
                    this.initKtDataTable();
                }, 200);
            }
        },
        user: function(user) {
            if (user) {
                console.log("Component(SiteTags)::watch(user) called with :", user);
                this.initKtDataTable();
            }
        }
    },

    computed: {
        // -- Computed -- Property will only re-evaluate when some of its reactive dependencies have changed.
        // To compose new data from existing datasource
        // To reference a value from the template (cached value)
        // --
        ...mapGetters(["currentSite", "siteTagTypes", "tagTypeObjsByName", "user", "createAnotherTagType"])
    },

    methods: {
        // -- Methods -- Property to perform an action.
        // To react on some event happening in the DOM (called every time an event occurs even if method returns the same result)
        // To call a function when something happens in your component (from property "computed" or "watch")
        // ---
        ...mapActions(["showDeleteModal", "showImportTagModelsModal", "resetTagTypesState", "getSiteTagTypes"]),
        onSearch() {
            if (this.siteTagModelsTable) {
                this.siteTagModelsTable.search(this.searchedValue, "tagTypeModel");
            }
        },
        onEditTag: function(tagTypeId) {
            this.$router.push({ name: "editTagModel", params: { tagTypeId: tagTypeId, siteId: this.siteId } });
        },
        registerEventsOnSiteTagModelsTable() {
            var self = this;
            $("#tag_models_datatable").on("kt-datatable--on-layout-updated", () => {
                $(".deleteTagModelButton")
                    .off()
                    .on("click", function() {
                        let tagTypeId = $(this).attr("data-tagTypeId");
                        let tagTypeModel = $(this).attr("data-tagTypeModel");
                        console.log("Component(SiteTagModels)::registerEventsOnSitesTable(deleteTagModelButton) clicked. tagTypeid = " + tagTypeId);
                        self.showDeleteModal({
                            textContent: i18n.t("tag_deleteTagModelConfirmText", { tagTypeModel: tagTypeModel }),
                            actionName: "DELETE_TAG_MODEL", params: { siteId: self.siteId, tagTypeId: tagTypeId } });
                    });
                $(".editTagModelButton")
                    .off()
                    .on("click", function() {
                        let tagTypeId = $(this).attr("data-tagTypeId");
                        console.log("Component(SiteTagModels)::registerEventsOnSitesTable(editTagModelButton) clicked. tagTypeid = " + tagTypeId);
                        // Hide and destroy element’s tooltip
                        $('[data-toggle="kt-tooltip"]').tooltip("dispose");
                        // Go to edit vue
                        self.onEditTag(tagTypeId);
                    });
                // Force width pager size
                setTimeout(() => {
                    $(".kt-datatable__pager-size").css("width", "80px");
                    // Init tooltips
                    $('[data-toggle="kt-tooltip"]').tooltip({ trigger: "hover" });
                }, 50);
            });
        },
        initKtDataTable() {
            // Prepa data
            let data = [];
            let siteTagTypes = [];
            if (this.siteTagTypes && this.siteTagTypes.length && this.currentSite) {
                let tagTypes = this.siteTagTypes.filter(tagType => tagType.name !== "UNIVERSAL" && tagType.isUsedAsTag === true);

                if (this.currentSite.BLEGatewaysType === "OMNIACCESS_OEM") {
                    const tagTypeNames = ["ASSET", "CARD"];
                    tagTypes = tagTypes.filter(tagType => !tagTypeNames.includes(tagType.name.toUpperCase()))
                }
                siteTagTypes = tagTypes;
            } else {
                siteTagTypes = this.siteTagTypes;
            }

            if (siteTagTypes && siteTagTypes.length > 0) {
                data = siteTagTypes.map((tagType) => {
                    let finalTagType = {...tagType};
                    finalTagType.formatUpdatedAt = moment(tagType.updatedAt).format(commonVueHelper.getDateStringFormatFromLocale(moment().locale()));
                    finalTagType.model = tagType.name;
                    if (finalTagType.isDefault) {
                        finalTagType.tagTypeModel = commonVueHelper.getPropFromTagType("fullRef", tagType);
                    } else {
                        finalTagType.tagTypeModel = tagType.name + " (" + tagType.reference + ")";
                    }
                    if (!finalTagType.image) {
                        finalTagType.image = "/assets/tags/universal.svg";
                    }
                    return finalTagType;
                });
            }

            const options = {
                data: {
                    type: "local",
                    source: commonVueHelper.preventHtmlInjection(data),
                    pageSize: 20,
                    saveState: {
                        webstorage: false
                    }
                },
                layout: commonVueHelper.getLayoutOptions(),
                translate: commonVueHelper.getTranslateOptions(),
                toolbar: commonVueHelper.getToolbarOptions(),
                sortable: !0,
                pagination: !0,
                columns: [
                    {
                        field: "tagTypeModel",
                        title: i18n.t("MAP_TAG_TYPE"),
                        default: "-",
                        textAlign: "left",
                        overflow: "visible",
                        autoHide: false,
                        template: function(row) {
                            if (row.model && row.reference) {
                                var createdAt = moment(row.createdAt);
                                var now = moment();
                                var duration = moment.duration(now.diff(createdAt));
                                var minutes = duration.asMinutes();
                                if (minutes < 15) {
                                    if (row.isDefault) {
                                        return '\
                                        <div class="kt-user-card-v2">\
                                            <div class="kt-user-card-v2__details kt-user-card-v2__name ">\
                                                <span class="kt-user-card-v2__name"">' + row.tagTypeModel + "<span class='labelNew'>" + i18n.t("common_new") + "</span></span>\
                                            </div>\
                                        </div>";
                                    } else {
                                        return '\
                                            <div class="kt-user-card-v2">\
                                                <div class="kt-user-card-v2__details openResourceLinkTag">\
                                                    <a class="editTagModelButton kt-link kt-user-card-v2__name" data-tagTypeId="' + row.id + '" href="javascript:;">' + row.tagTypeModel + "<span class='labelNew'>" + i18n.t("common_new") + "</span></a>\
                                                </div>\
                                            </div>\
                                        ";
                                    }
                                } else {
                                    if (row.isDefault) {
                                        return '\
                                        <div class="kt-user-card-v2">\
                                            <div class="kt-user-card-v2__details kt-user-card-v2__name ">\
                                                <span class="kt-user-card-v2__name"">' + row.tagTypeModel + "</span>\
                                            </div>\
                                        </div>";
                                    } else {
                                        return '\
                                            <div class="kt-user-card-v2">\
                                                <div class="kt-user-card-v2__details openResourceLinkTag">\
                                                    <a class="editTagModelButton kt-link kt-user-card-v2__name" data-tagTypeId="' + row.id + '" href="javascript:;">' + row.tagTypeModel + "</a>\
                                                </div>\
                                            </div>\
                                        ";
                                    }
                                }
                            } else {
                                return "-";
                            }
                        }
                    },
                    {
                        field: "icon",
                        title: i18n.t("tag_tagModelsIcon"),
                        textAlign: "center",
                        width: 250,
                        sortable: false,
                        template: function(row) {
                            if (row.isDefault) {
                                let iconUrl = "/assets/tags/" + row.name.toLowerCase() + ".svg";
                                return `<img class="tagsIconPreview" src="${iconUrl}" /></img>`;
                            } else {
                                let currentIcon = row.image;
                                return (
                                    `<img class="tagsIconPreview" src="${currentIcon}" />`
                                );
                            }
                        }
                    },
                    {
                        field: "updatedAt",
                        title: i18n.t("common_lastUpdateDate"),
                        textAlign: "center",
                        sortable: "desc",
                        template: function(row) {
                            return row.formatUpdatedAt;
                        }
                    },
                    {
                        field: "Actions",
                        title: i18n.t("common_actions"),
                        sortable: false,
                        width: 110,
                        overflow: "visible",
                        autoHide: false,
                        textAlign: "center",
                        template: function(row) {
                            if(row.isDefault) {
                                return "-"
                            }
                            else {
                                return (
                                    `
                                        <button data-toggle="kt-tooltip" data-placement="top" data-original-title="` +
                                    i18n.t("common_edit") +
                                    `" type="button" data-tagTypeId="` +
                                    row.id +
                                    `" data-macaddress="` +
                                    row.macAddress +
                                    `" class="btn btn-outline-brand btn-sm btn-icon editTagModelButton">
                                            <i class="la la-pencil"></i>
                                        </button>
                                        <button data-toggle="kt-tooltip" data-placement="top" data-original-title="` +
                                    i18n.t("common_delete") +
                                    `" type="button" data-tagTypeId="` +
                                    row.id +
                                    `" data-tagTypeModel="` +
                                    row.tagTypeModel +
                                    `" class="btn btn-outline-danger btn-sm btn-icon deleteTagModelButton">
                                            <i class="la la-trash"></i>
                                        </button>
                                    `
                                );
                            }
                        }
                    }
                ]
            };

            if (this.siteTagModelsTable) {
                $("#tag_models_datatable").KTDatatable().destroy();
                // After destroy set to null
                this.siteTagModelsTable = null;
            }

            // According to source list length, show datatable or empty list icon+text
            if (options.data.source && options.data.source.length > 0) {
                // There is data => Hide empty list icon+text
                this.isEmptyList = false;
                // Now, we are ready to build the table
                this.siteTagModelsTable = $("#tag_models_datatable").KTDatatable(options);
                // Once table is build, register click events on buttons inside the table
                this.registerEventsOnSiteTagModelsTable();
            } else {
                // There is no data => Show empty list icon+text
                this.isEmptyList = true;
            }
        }
    },
    components: {
        // -- Components -- List of local components used in the current template
        // --
        "app-emptylist": EmptyList,
        "app-sitetitle": SiteTitle
    }
};
</script>

<style scoped>
.baseTemplate {
    display: contents;
}
</style>
